<div>
    <button  class="resetIcon" (click)=resetFilters() ><i class="fa-solid fa-rotate-right fa-rotate-180" style="color: #52aef4;"></i></button> </div>
